module.exports = __webpack_public_path__ + "img/master.0f7e94f7.svg";